export const SYNOPTIC_TEMPLATES_UPDATE_CHANNEL = 'synopticTemplatesUpdateChannel'
export const TEXT_TEMPLATES_UPDATE_CHANNEL = 'textTemplatesUpdateChannel'
